import React, { useState, useEffect } from 'react';
import { Row, Button, Modal, Dropdown } from "react-bootstrap";

import TodayShift from '../TodayShift/TodayShift';
import Teamsb2b from '../Teamsb2b/Teamsb2b';
import Holidays from '../Holidays/Holidays';
import _WorkedHours from '../../clockResgistry/WorkedHours/WorkedHours';
import WhosWorking from '../WhosWorking/WhosWorking';
import AdminInbox from '../AdminInbox/AdminInbox';
import Calendarb2b from '../Calendarb2b/Calendarb2b';
import { formatTime as formatConfiguredTime } from '../../../utils/timeFormat';

const LandingPage = () => {
    const [showModal, setShowModal] = useState(false);
    const [modalAction, setModalAction] = useState('');
    const [clockState, setClockState] = useState('not_started');
    const [dropdownTitle, setDropdownTitle] = useState('Escritório');
    const [pauseStartTime, setPauseStartTime] = useState(null);
    const [_totalPauseDuration, setTotalPauseDuration] = useState('00:00');
    const [currentPauseDuration, setCurrentPauseDuration] = useState('00:00');
    const [entryTime, setEntryTime] = useState(null);
    const [exitTime, setExitTime] = useState(null);
    const [pauseDurations, setPauseDurations] = useState([]);

    const resetTimers = () => {
        setPauseStartTime(null);
        setTotalPauseDuration('00:00');
        setCurrentPauseDuration('00:00');
        setEntryTime(null);
        setExitTime(null);
        setPauseDurations([]);
        setClockState('not_started');
    };

    useEffect(() => {
        let interval;

        if (clockState === 'paused' && pauseStartTime) {
            interval = setInterval(() => {
                const now = new Date();
                const pauseDiff = now - pauseStartTime;

                const hours = Math.floor(pauseDiff / (1000 * 60 * 60)).toString().padStart(2, '0');
                const minutes = Math.floor((pauseDiff % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
                setCurrentPauseDuration(`${hours}:${minutes}`);
            }, 1000);
        }

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [clockState, pauseStartTime]);


    const calculateTotalPauseDuration = (durations) => {
        const totalMinutes = durations.reduce((total, duration) => {
            const [hours, minutes] = duration.split(':').map(Number);
            return total + (hours * 60) + minutes;
        }, 0);

        const totalHours = Math.floor(totalMinutes / 60);
        const remainingMinutes = totalMinutes % 60;

        return `${totalHours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`;
    };

    const handleConfirmarAction = () => {
        setShowModal(false);
        switch (modalAction) {
            case 'start':
                resetTimers();
                setPauseStartTime(null);
                setEntryTime(new Date());
                setClockState('working');
                break;
            case 'pause':
                setClockState('paused');
                setPauseStartTime(new Date());
                break;
            case 'return':
                if (currentPauseDuration !== '00:00') {
                    setPauseDurations(prev => [...prev, currentPauseDuration]);
                    setTotalPauseDuration(calculateTotalPauseDuration([...pauseDurations, currentPauseDuration]));
                }
                setClockState('working');
                setPauseStartTime(null);
                setCurrentPauseDuration('00:00');
                break;
            case 'leave':
                if (clockState === 'paused' && currentPauseDuration !== '00:00') {
                    setPauseDurations(prev => [...prev, currentPauseDuration]);
                    setTotalPauseDuration(calculateTotalPauseDuration([...pauseDurations, currentPauseDuration]));
                }
                setExitTime(new Date());
                setClockState('not_started');
                break;
            default:
                resetTimers();
                break;
        }
    };

    const formatTime = (time) => {
        return time ? formatConfiguredTime(time, { locale: 'pt-PT' }) : '-';
    };

    const handleShowModal = (action) => {
        setModalAction(action);
        if (action === 'start') {
            setDropdownTitle('Escritório');
        } else if (action === 'pause') {
            setDropdownTitle('Almoço');
        } else if (action === 'return') {
            setDropdownTitle('Escritório');
        } else {
            setDropdownTitle('Escritório');
        }
        setShowModal(true);
    };

    const getModalTitle = () => {
        switch (modalAction) {
            case 'start':
                return 'Registar Entrada';
            case 'pause':
                return 'Registar Pausa';
            case 'return':
                return 'Registar Retorno';
            case 'leave':
                return 'Registar Saída';
            default:
                return 'Registar Ponto';
        }
    };

    const getModalButtonText = () => {
        switch (modalAction) {
            case 'start':
                return 'Registar Entrada';
            case 'pause':
                return 'Registar Pausa';
            case 'return':
                return 'Registar Retorno';
            case 'leave':
                return 'Registar Saída';
            default:
                return 'Confirmar';
        }
    };

    const dropDownBtnStyles = {
        backgroundColor: "#1E0342",
        color: "white",
        borderBottom: "1px solid white",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderColor: "white"
    }

    const dropDownItemStyles = {
        backgroundColor: "#1E0342",
        borderColor: "white",
        border: "1px solid white"
    }

    return (
        <div style={{ background: '#1E0342', height: "100vh", overflowX: 'hidden' }} className='custom-scroll'>

        {/* 1ª row */}
        <Row className='d-flex justify-content-center mt-3 m-3' style={{ height: '30%'}}>
            <TodayShift clockState={clockState} entryTime={entryTime} exitTime={exitTime} formatTime={formatTime} handleShowModal={handleShowModal} />
            <Teamsb2b />
            <Holidays />
        </Row>

        {/* modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Body style={{ backgroundColor: "#17296B" }}>
                <Modal.Title className='text-white d-flex justify-content-center'>{getModalTitle()}</Modal.Title>
                <img
                    src="https://media.istockphoto.com/id/1469376700/pt/vetorial/map-of-the-portuguese-azores-island-of-terceira.jpg?s=612x612&w=0&k=20&c=cVzyrkFDjpceT1ExkAMV3GWgteOF5EsTzPJlu7eSdss="
                    className="w-100 rounded-top"
                />
                {modalAction !== 'return' && modalAction !== 'leave' && (
                    <Dropdown className='w-100 mb-2'>
                        <Dropdown.Toggle
                            className="w-100"
                            style={{ ...dropDownBtnStyles }}
                        >
                            {dropdownTitle}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100" style={{ ...dropDownItemStyles }}>
                            {modalAction === 'start' && (
                                <>
                                    <Dropdown.Item
                                        onClick={() => setDropdownTitle('Escritório')}
                                        style={{ ...dropDownBtnStyles }}
                                    >
                                        Escritório
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => setDropdownTitle('COpE')}
                                        style={{
                                            backgroundColor: "#1E0342",
                                            color: "white"
                                        }}
                                    >
                                        COpE
                                    </Dropdown.Item>
                                </>
                            )}
                            {modalAction === 'pause' && (
                                <>
                                    <Dropdown.Item
                                        onClick={() => setDropdownTitle('Almoço')}
                                        style={{ ...dropDownBtnStyles }}
                                    >
                                        Almoço
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => setDropdownTitle('Interrupção')}
                                        style={{
                                            backgroundColor: "#1E0342",
                                            color: "white"
                                        }}
                                    >
                                        Interrupção
                                    </Dropdown.Item>
                                </>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
                <span className='text-white'>Ao tocar no botão abaixo, a sua locallização será compartilhada com o seu gestor</span>
                <Button
                    className="w-100 mt-3 border-white border-bottom border-start border-end"
                    style={{ backgroundColor: "#1E0342", color: "white" }}
                    onClick={handleConfirmarAction}
                >
                    <b>{getModalButtonText()}</b>
                </Button>
            </Modal.Body>
        </Modal>

        {/* 2ª row  */}
        <Row className='d-flex justify-content-center m-3' style={{ height: '30%' }}>
            <WhosWorking />
        </Row>

        {/* 3ª row */}
        <Row className="d-flex justify-content-center m-3 mt-5" style={{ height: '30%' }}>
            <AdminInbox />
            <Calendarb2b />
        </Row>
</div>
    )
}

export default LandingPage;
